jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.news-posts').length ) {

        let $ = jQuery;
        const $container = $(".js-news-wrapper");
        const $loadMoreBtn = $("#load-more-news");
        const $newsFilter = $(".news-filter");

        const $pageLink = $(".page-link");

        const $loadingString = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

        $loadMoreBtn.on("click", function () {
            loadResults();
        });

        $newsFilter.on("change", function () {
            $dataFor = $(this).data('for');
            $value = $(this).val();
            $container.attr('data-'+$dataFor, $value);
            if($dataFor == 'year' && $container.attr('data-month') == '') {
                return;
            }
            $container.empty().append($loadingString);
            setTimeout(function() {
                loadResults(1);
            }, 700);
        });

        $(document).on("click", ".page-link", function () {
            $this = $(this);
            if($this.hasClass('current-page') || $this.hasClass('disabled')) {
                return;
            }
            $page = $this.data("page");
            $container.empty().append($loadingString);
            setTimeout(function() {
                loadResults($page);
            }, 700);
        });


        function loadResults($page) {

            $currentPage    = $container.attr('data-page');
            $perPage        = $container.attr('data-posts_per_page');
            $category       = $container.attr('data-category');
            $month          = $container.attr('data-month');
            $year           = $container.attr('data-year');
            $nextPage       = $page;


            var sendData = {
                action:     'news_ajax_handler',
                page:       $currentPage,
                nextPage:   $nextPage,
                perPage:    $perPage,
                month:      $month,
                year:       $year,
                category:   $category,
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function() {
                    $loadMoreBtn.hide();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    $loadMoreBtn.remove();
                },
                success: function(data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);
                    $container.empty().append(htmlData);
                },
                complete: function(data) {
                    // if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                    //     console.log($currentPage);
                    //     $container.attr('data-page', $currentPage);
                    // }
                    AOS.init();
                }
            });
        }

    }
});